/* Hello couleur — champ code promo sur la page panier.
   Le client saisit un code → on l'applique via /discount/CODE (mecanisme Shopify
   officiel, fonctionne meme anonyme) → on verifie sur /cart.js si le code est
   reellement applicable → si oui reload (le recap re-rend la ligne remise
   server-side), si non message d'erreur sans reload. Pas de remise "par defaut" :
   rien ne s'applique sans saisie. */
(function () {
  var form = document.querySelector('[data-discount-form]');
  if (!form) return; // deja une remise appliquee → pas de champ

  var input = form.querySelector('[data-discount-input]');
  var btn = form.querySelector('[data-discount-submit]');
  var errorEl = document.querySelector('[data-discount-error]');

  function showError(msg) {
    if (!errorEl) return;
    errorEl.textContent = msg;
    errorEl.hidden = false;
  }

  function applyCode(code) {
    // 1) applique le code a la session (suit la redirection, corps ignore)
    return fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
      .then(function () {
        // 2) relit l'etat reel du panier
        return fetch('/cart.js', { credentials: 'same-origin' });
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var codes = cart.discount_codes || [];
        return codes.some(function (d) {
          return d.code && d.code.toUpperCase() === code.toUpperCase() && d.applicable;
        });
      });
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var code = (input.value || '').trim();
    if (!code) return;
    if (errorEl) errorEl.hidden = true;

    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = '…';

    applyCode(code).then(function (ok) {
      if (ok) {
        window.location.reload();
      } else {
        btn.disabled = false;
        btn.textContent = original;
        showError("Ce code n'est pas valide ou ne s'applique pas à votre panier.");
      }
    }).catch(function () {
      btn.disabled = false;
      btn.textContent = original;
      showError("Une erreur s'est produite. Veuillez réessayer.");
    });
  });
})();
